import styled from "styled-components";

export const Content = styled.span`
	color: ${(props) => (props.color ? props.color : "white")};
	text-align: ${(props) => (props.align ? props.align : "left")};
	vertical-align: middle;
`;
